import {PaginaLogada} from "../../componentes";
import React, {useEffect, useState} from "react";
import {exibirMensagemSucesso} from "../../util";
import CardPadrao from "../../componentes/card/card-padrao";
import {Grid, Modal, Table, Text, TextInput, Title} from "@mantine/core";
import {COL_RESP_2, COL_RESP_3, COL_RESP_4, COL_RESP_8, COR, ICONE} from "../../config/constantes/constantes-mantine";
import {BotaoExcluir, BotaoMantine, BotaoSalvar} from "../../componentes/botao/botao-mantine";
import CursoServico from "../../servicos/curso-servico";
import {Curso} from "../../tipos/curso";
import {useForm} from "@mantine/form";
import {CursoCmd} from "../../tipos/cmd/curso-cmd";
import {DateTimePicker} from "@mantine/dates";
import {useDisclosure, useListState} from "@mantine/hooks";
import {formatarDataHoraLocaleString, formatarTelefone} from "../../util/mascara";
import {Inscricao} from "../../tipos/Inscricao";
import {IconExclamationCircle, IconFileTypeCsv, IconSortAscendingNumbers} from "@tabler/icons-react";
import {modals} from "@mantine/modals";
import {AnimatePresence, motion} from "framer-motion";
import { ScrollArea } from "@mantine/core";
import { useScrollIntoView } from "@mantine/hooks";
import { Group } from "@mantine/core";
import { IconDownload } from "@tabler/icons-react";

export default function CadastrarCurso() {

  const [isCarregando, setIsCarregando] = useState(false)
  const [cursos, handlersCursos] = useListState<Curso>()
  const [inscritos, setInscritos] = useState<Inscricao[]>()
  const [curso, setCurso] = useState<Curso>()
  const [modalExibir, {open: openExibir, close: closeExibir}] = useDisclosure(false)
  const [modalSorteio, {open: openSorteio, close: closeSorteio}] = useDisclosure(false)
  const [visible, setVisible] = useState<number>(0);
  const { scrollIntoView, targetRef, scrollableRef } = useScrollIntoView<HTMLDivElement>({ duration: 300 });


  const form = useForm<CursoCmd>({
    initialValues: new CursoCmd(),
    validateInputOnBlur: true,
    validate: {
      nome: (value) => (value.length <= 4 ? "Nome muito curto" : null),
      descricao: (value) => (value.length <= 4 ? "Descrição muito curta" : null),
      dataFim: (value, values) => {
        const fim = new Date(value)
        const inicio = new Date(values.dataInicio)
        if (fim.getTime() < inicio.getTime()) return "Data fim menor que data inicio"
        return null
      },
    },
  });

  function buscarCursos() {
    setIsCarregando(true)
    CursoServico.buscarCursos()
      .then(dados => handlersCursos.setState(dados))
      .finally(() => setIsCarregando(false))
  }
  function salvarCurso() {
    setIsCarregando(true)
    CursoServico.salvarCurso(form.getValues())
      .then(dados => {
        handlersCursos.append(dados)
        exibirMensagemSucesso("Curso cadastrado com sucesso")
      })
      .finally(() => setIsCarregando(false))
  }

  function deletar(c: Curso) {
    setIsCarregando(true)
    CursoServico.deletarCurso(c.id)
      .then((res) => {
        if (res) {
          exibirMensagemSucesso("Curso deletado com sucesso")
          buscarCursos()
        }
      })
      .finally(() => setIsCarregando(false))
  }

  function exibirInscritos(curso: Curso) {
    setIsCarregando(true)
    setCurso(curso)
    CursoServico.listarInscritos(curso.id)
      .then(dados => {
        setInscritos(dados)
        openExibir()
      }).finally(() => setIsCarregando(false))
  }

  function confirmarSorteio(curso: Curso) {
    modals.openConfirmModal({
      title: 'Sortear Vagas Curso',
      children: (
        <>
          <Text>
            Deseja realmente realizar o sorteio do curso {curso.nome}?
          </Text>
          <Text mt={20}>
            <IconExclamationCircle color={"red"} /> Esta ação não pode ser desfeita!
          </Text>
        </>
      ),
      labels: {confirm: 'Sortear', cancel: 'Cancelar'},
      confirmProps: {color: 'yellow'},
      onConfirm: () => sortearInscritos(curso)
    })
  }

  function sortearInscritos(curso: Curso) {
    setIsCarregando(true)
    CursoServico.sortearInscritos(curso.id).then(dados => {
      setInscritos(dados)
      setCurso(curso)
      setVisible(0)
      openSorteio()
    }).finally(() => setIsCarregando(false))
  }

  const buildExportRows = () => {
    return (inscritos ?? []).map((i) => ({
      Ordem: i.ordem ?? "",
      Nome: i.usuario?.nome ?? "",
      Email: i.usuario?.email ?? "",
      Telefone: formatarTelefone(i.telefone) ?? "",
      "Data da Inscrição": formatarDataHoraLocaleString(i.dataHoraInscricao),
    }));
  };

  function downloadCSV() {
    const rows = buildExportRows();
    const headers = ["Ordem", "Nome", "Email", "Telefone", "Data da Inscrição"];

    const escape = (val: unknown) => `"${String(val ?? "").replace(/"/g, '""')}"`;
    const csv = [
      headers.join(";"),
      ...rows.map((r) => headers.map((h) => escape((r as any)[h])).join(";")),
    ].join("\n");

    const blob = new Blob([new TextEncoder().encode(csv)], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Inscritos-${curso?.nome ?? "curso"}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  }
  const botaoDownloadCsv = (
    <BotaoMantine
      leftSection={<IconDownload size={16} />}
      rightSection={<IconFileTypeCsv size={20} />}
      onClick={downloadCSV}>
      Baixar CSV
    </BotaoMantine>)

  useEffect(() => {
    buscarCursos()
  }, [])

  useEffect(() => {
    if (visible < inscritos?.length!!) {
      const timer = setTimeout(() => {
        setVisible((prev) => prev + 1);
      }, 500); // 500ms entre cada linha
      return () => clearTimeout(timer);
    }
  }, [visible, inscritos?.length]);

  useEffect(() => {
    if (visible > 0) {
      scrollIntoView({ alignment: 'end' });
    }
  }, [visible, scrollIntoView]);

  return (
    <PaginaLogada titulo="Gerenciar Curso" isCarregando={isCarregando}>
      <CardPadrao>
        <form onSubmit={form.onSubmit(salvarCurso)}>
          <Grid>
            <Grid.Col span={COL_RESP_4}>
              <TextInput
                label={"Nome"}
                {...form.getInputProps('nome')}
                onChange={(e) => form.setFieldValue("nome", e.target.value.toUpperCase())}
              />
            </Grid.Col>
            <Grid.Col span={COL_RESP_8}>
              <TextInput
                label={"Descrição"}
                {...form.getInputProps('descricao')}
                onChange={(e) => form.setFieldValue("descricao", e.target.value.toUpperCase())}
              />
            </Grid.Col>
            <Grid.Col span={COL_RESP_3}>
              <DateTimePicker
                label={"Data de Início"}
                {...form.getInputProps('dataInicio')}
              />
            </Grid.Col>
            <Grid.Col span={COL_RESP_3}>
              <DateTimePicker
                label={"Data Fim"}
                {...form.getInputProps('dataFim')}
              />
            </Grid.Col>
            <Grid.Col span={COL_RESP_2} style={{alignSelf: "flex-end"}}>
              <BotaoSalvar type={'submit'} />
            </Grid.Col>
          </Grid>
        </form>
      </CardPadrao>
      <CardPadrao titulo="Cursos cadastrados" mt={50}>
        <Table variant="vertical" withTableBorder>
          <Table.Tbody>
            {cursos.map((c, k) => {
              return (
                <Table.Tbody key={k}>
                  <Table.Tr>
                    <Table.Th>Nome</Table.Th>
                    <Table.Td>{c.nome}</Table.Td>
                  </Table.Tr>

                  <Table.Tr>
                    <Table.Th>Descricao</Table.Th>
                    <Table.Td>{c.descricao}</Table.Td>
                  </Table.Tr>

                  <Table.Tr>
                    <Table.Th>Data Inicio Inscrição</Table.Th>
                    <Table.Td>{formatarDataHoraLocaleString(c.dataInicioInscricao)}</Table.Td>
                  </Table.Tr>
                  <Table.Tr>
                    <Table.Th>Data Fim Inscrição</Table.Th>
                    <Table.Td>{formatarDataHoraLocaleString(c.dataFimInscricao)}</Table.Td>
                  </Table.Tr>
                  <Table.Tr>
                    <Table.Th>Ação</Table.Th>
                    <Table.Td>
                      <BotaoMantine m={5} icone={ICONE.EXIBIR} onClick={() => exibirInscritos(c)}>Inscritos</BotaoMantine>
                      <BotaoMantine m={5}  disabled={c.sorteado} color={COR.ALERTA} icone={IconSortAscendingNumbers} onClick={() => confirmarSorteio(c)}>Sortear</BotaoMantine>
                      <BotaoExcluir m={5} onClick={() => {deletar(c)}} />
                    </Table.Td>
                  </Table.Tr>

                </Table.Tbody>
              )
            })}
          </Table.Tbody>
        </Table>
      </CardPadrao>

      <Modal opened={modalExibir} onClose={closeExibir} title={curso?.nome} size={"100%"}>
        <Group justify="space-between" mb="xs">
          <Title order={5}>{inscritos?.length} Inscritos</Title>
          {botaoDownloadCsv}
        </Group>
        <Table>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Ordem</Table.Th>
              <Table.Th>Nome</Table.Th>
              <Table.Th>Email</Table.Th>
              <Table.Th>Telefone</Table.Th>
              <Table.Th>Data da Inscrição</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {inscritos?.map((i, k) => {
              return (
                <Table.Tr key={k}>
                  <Table.Td>{i.ordem}</Table.Td>
                  <Table.Td>{i.usuario.nome}</Table.Td>
                  <Table.Td>{i.usuario.email}</Table.Td>
                  <Table.Td>{formatarTelefone(i.telefone)}</Table.Td>
                  <Table.Td>{formatarDataHoraLocaleString(i.dataHoraInscricao)}</Table.Td>
                </Table.Tr>
              )
            })}
          </Table.Tbody>
        </Table>
      </Modal>

      <Modal opened={modalSorteio} onClose={closeSorteio} title={"Sorteio efetuado com sucesso!"} size={"100%"}>
        <Group justify="space-between" mb="xs">
          <div>
            <Title order={5}>{curso?.nome}</Title>
            <Title order={5}>{inscritos?.length} Inscritos</Title>
          </div>
          {botaoDownloadCsv}
        </Group>

        <ScrollArea h="60vh" viewportRef={scrollableRef}>
          <Table>
            <Table.Thead>
              <Table.Tr>
                <Table.Th>Ordem</Table.Th>
              <Table.Th>Nome</Table.Th>
              <Table.Th>Email</Table.Th>
              <Table.Th>Data da Inscrição</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            <AnimatePresence>
            {inscritos?.slice(0, visible).map((i) => {
              return (
                <motion.tr
                  key={i.id}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  <Table.Td>{i.ordem}</Table.Td>
                  <Table.Td>{i.usuario.nome}</Table.Td>
                  <Table.Td>{i.usuario.email}</Table.Td>
                  <Table.Td>{formatarDataHoraLocaleString(i.dataHoraInscricao)}</Table.Td>
                </motion.tr>
              )
            })}
            </AnimatePresence>

            {/* Sentinela para o scroll */}
            <tr>
              <td colSpan={4}>
                <div ref={targetRef as unknown as React.LegacyRef<any>} />
              </td>
            </tr>
          </Table.Tbody>
        </Table>
        </ScrollArea>

      </Modal>
    </PaginaLogada>
  );
}
